import getLatitude from '../getters/getLatitude';
import getLongitude from '../getters/getLongitude';

function hasLocationPointCoordsChanged(prevPoint, newPoint) {
  return (
    getLongitude(prevPoint) !== getLongitude(newPoint) ||
    getLatitude(prevPoint) !== getLatitude(newPoint)
  );
}

export default hasLocationPointCoordsChanged;
